import { Box } from "@mui/material";
import React, { useMemo } from "react";

import { AppliedFilter } from "../../filters/filter-context";
import { useDayActivityController } from "../controllers/use-day-activity-controller";
import { useWorkerActivityData } from "../controllers/use-worker-activity-data";
import DailyActivityTable from "./ui/daily-activity-table";
import TableHeader from "./ui/table-header";

const DailyActivityReport = () => {
	const { currentUserId, workerActivityFilters, allDailyActivityReportData } = useWorkerActivityData();
	
	const [
		{
			currentDate,
			filteredData,
			sidebarFilteredData,
			exportData,
			search,
			columnSelector,
			open,
			selectedKPI,
			KPICount,
		},
		{
			setCurrentDate,
			setSearch,
			setColumnSelector,
			setFilterOpen,
			setSelectedKPI,
		},
	] = useDayActivityController();

	// Create default applied filters for Reporting Manager set to current user
	const defaultAppliedFilters = useMemo(() => {
		if (workerActivityFilters?.managers?.length > 0 && currentUserId) {
			// Find the current user in the managers list
			const currentUserManager = workerActivityFilters.managers.find(
				(manager) => manager.id.toString() === currentUserId.toString()
			);
			
			if (currentUserManager) {
				// Check if there's data for this reporting manager
				const hasData = allDailyActivityReportData?.some(
					worker => worker.reportingManagerId?.toString() === currentUserId.toString()
				);
				
				// Only apply filter if there's data available
				if (hasData) {
					return [{
						type: "Reporting Manager",
						timeAdded: Date.now(),
						data: [
							{
								id: currentUserManager.id.toString(),
								timeAdded: Date.now(),
								name: currentUserManager.name,
							},
						],
					}];
				}
			}
		}
		
		return [];
	}, [currentUserId, workerActivityFilters, allDailyActivityReportData]);

	return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <TableHeader
        date={currentDate}
        setDate={setCurrentDate}
        search={search}
        setSearch={setSearch}
        columnSelector={columnSelector}
        setColumnSelector={setColumnSelector}
        exportData={exportData}
        open={open}
        setFilterOpen={setFilterOpen}
      />
      <DailyActivityTable
        data={filteredData}
        search={search}
        columnSelector={columnSelector}
        open={open}
        selectedKPI={selectedKPI}
        setSelectedKPI={setSelectedKPI}
        KPICount={KPICount}
        defaultAppliedFilters={defaultAppliedFilters}
      />
    </Box>
  );
};

export default DailyActivityReport;
